import {
    NewsletterSubscriptionComponent as SourceNewsletterSubscriptionComponent,
} from 'SourceComponent/NewsletterSubscription/NewsletterSubscription.component';

import './NewsletterSubscription.override.style';
import newsletterSubscriptionForm from 'SourceComponent/NewsletterSubscription/NewsletterForm.form';
import React from "react";
import { FieldType } from '@scandipwa/scandipwa/src/component/Field/Field.config';

export class NewsletterSubscriptionComponent extends SourceNewsletterSubscriptionComponent {
    fieldMap() {
        return newsletterSubscriptionForm();
    }

    renderActions() {
        return (
            <button
                type={FieldType.SUBMIT}
                aria-label={'Submit'}
            >
                {'Subscribe'}
            </button>
        );
    }

    renderFormBody() {
        const { isLoading } = this.props;

        return (
            <div>
                {super.renderFormBody()}
            </div>
        );
    }

    getFormProps() {
        const { onFormSubmit } = this.props;

        return {
            onSubmit: onFormSubmit,
        };
    }

    render() {
        return (
            <div>
                <h3 className='newsletter-title footer-column-items-title'>You can be one step ahead</h3>
                <span className='newsletter-text'>Send me BlueHira news, updates and offers.</span>
                {super.render()}
            </div>
        );
    }
}

export default NewsletterSubscriptionComponent;
